<template>
  <span class="sidebar-star">
    <svg width="16" height="16" viewBox="0 0 24 24" :fill="color" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01z"/>
    </svg>
  </span>
</template>

<script>
export default {
  name: 'SidebarStar',
  props: {
    active: {
      type: Boolean,
      default: false,
      
    }
  },
  computed: {
    color() {
      return this.active ? '#2EA2FA' : '#fff';
    }
  }
};
</script>

<style scoped>
.sidebar-star {
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
}
</style>
